import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTracking } from "../../hooks/useTracking";

import TitleSection from "../TitleSection/TitleSection";
import SubtitleSection from "../SubtitleSection/SubtitleSection";
import ImgClinicas from "../../assets/Page_1/1.4_Colaboraciones/Illustration.svg";

import "./SectionColab.css";

const SectionColab = () => {
  const [searchParams] = useSearchParams();
  const { trackEvent } = useTracking();

  // Rescatamos el hospital de la URL si existe, para no perder la atribución
  const hospitalClient = searchParams.get("hospital") || "Vertex_Lab_Direct";

  const handleClinicasClick = () => {
    trackEvent("click_nav_clinicas", {
      hospital_client: hospitalClient,
      test_name: "Home_Page", // Mandamos esto para que la tabla en GA4 no quede vacía
      source: "home_page_link"
    });
  };

  return (
    <section className="section-colaboraciones">
      <TitleSection titleSection={"Colaboración"} />
      <SubtitleSection
        subtitleSection={"Clínicas que respaldan tu bienestar"}
      />
      <p className="section-colaboraciones-paragraph">
        Si el resultado recomienda visita, te pondremos en contacto directo con
        una de nuestras {/* Agregamos el onClick directamente al Link */}
        <Link to={"./clinicas"} onClick={handleClinicasClick}>
          {" "}
          <span className="btn-clinicas">clínicas.</span>
        </Link>
      </p>
      <img src={ImgClinicas} alt="imagen_colab" className="img-clinicas" />
    </section>
  );
};

export default SectionColab;
